import { useEffect } from "react";
import { Helmet } from "react-helmet";


import '../pages/BioGas.css'
import BioGasBan from '../components/BioGasBan'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import RADLOGO from "../images/RADLOGO.jpeg";
import BIOGASWORK from "../images/BIOGASWORK.jpg";
import VID3 from "../images/videos/VIDEOS/VID3.mp4";
import BIOGAS from "../images/BIOGAS.jpg";
import {
  FaWater,

  FaCogs
} from "react-icons/fa";

import {
  FaSearch,
  FaDraftingCompass,
  FaTools,
  FaGasPump,

  FaCheckCircle,
  FaUserGraduate
} from "react-icons/fa";

import {
  FaUniversity,

  FaMoneyBillWave,
  FaChartLine,
  FaProjectDiagram
} from "react-icons/fa";


import {
  FaRecycle,
  FaFire,
  FaBolt,
  FaIndustry,
  FaHome,
  FaHospital,
  FaSeedling,
  FaLeaf
} from "react-icons/fa";



export default function BioGas() {


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  return (
    <>
      <Helmet>
        <title>Biogas Plant Installation & Solutions in Madurai | Waste to Energy</title>
        <meta name="description" content="Convert organic waste into renewable energy with our customized biogas plants in Madurai. Floating drum, fixed dome, and industrial biogas solutions by RAD EnviroNex." />
        <meta name="keywords" content="Biogas Plant Madurai, Waste to Energy Madurai, Bio-CNG Plant Tamil Nadu, Floating Drum Biogas, Fixed Dome Biogas, Organic Waste Management, Biogas for Hotels Madurai" />
        <link rel="canonical" href="https://radenvironex.com/BioGas" />
      </Helmet>
      <Navbar />


      <BioGasBan />


      {/* BIOGAS SECTION */}
      <section id="biogas-system-section">
        <div className="biogas-wrapper" data-aos="fade-up">

          <h2 style={{ color: '#0bbcd6', textAlign: 'center' }}>Biogas System</h2>

          <p className="biogas-intro">
            RAD EnviroNex provides customized biogas solutions that convert organic waste into renewable energy by waste assessment and feasibility study . Our biogas plants help  reduce waste disposal issues, lower energy costs, and promote circular economy practices by generating clean and sustainable fuel. We also provide testing, commissioning and performance guarantee.
          </p>

          {/* USES */}
          <div className="biogas-block" data-aos="slide-up">
            {/* <h3>Uses of Biogas</h3> */}
            <div className="biogas-grid">
              {/* <div><FaFire /> Cooking fuel</div>
        <div><FaBolt /> Electricity generation (biogas genset)</div>
        <div><FaIndustry /> Boiler & heating applications</div>
        <div><FaSeedling /> Organic manure for agriculture (by-product)</div> */}
            </div>
          </div>


          {/* TYPES OF BIOGAS PLANTS */}
          <section id="biogas-types-section">
            <div className="biogas-types-wrapper" data-aos="fade-up">

              <h2 style={{ color: '#0bbcd6', textAlign: 'center' }}>Types of Biogas Plants</h2>

              <div className="biogas-types-grid">

                <div data-aos="slide-up">
                  <FaWater />
                  <h4>Floating Drum Type</h4>
                  <p>
                    Traditional biogas plant with a floating steel gas holder that rises
                    and falls based on gas production.
                  </p>
                </div>

                <div data-aos="slide-up" data-aos-delay="100">
                  <FaHome />
                  <h4>Fixed Dome Type</h4>
                  <p>
                    Underground masonry structure with a fixed dome, low maintenance,
                    and long service life.
                  </p>
                </div>

                <div data-aos="slide-up" data-aos-delay="200">
                  <FaWater />
                  <h4>Balloon / Tubular Type</h4>
                  <p>
                    Flexible tubular digester suitable for rural and small-scale
                    applications with quick installation.
                  </p>
                </div>

                <div data-aos="slide-up" data-aos-delay="300">
                  <FaCogs />
                  <h4>Prefabricated Biogas Plants</h4>
                  <p>
                    Factory-made modular systems for faster installation and consistent
                    performance.
                  </p>
                </div>

                <div data-aos="slide-up" data-aos-delay="400">
                  <FaIndustry />
                  <h4>Industrial Biogas Plants</h4>
                  <p>
                    Large-scale plants with gas storage, purification systems, and
                    biogas gensets for power generation.
                  </p>
                </div>

              </div>
            </div>
          </section>

          {/* SUITABLE FOR */}
          <div className="biogas-block" data-aos="slide-up" data-aos-delay="100">
            <h3 style={{ color: '#0bbcd6', textAlign: 'center' }}>Best Suitable For</h3>
            <div className="biogas-grid">
              <div><FaHome /> Apartments & residential communities</div>
              <div><FaIndustry /> Hotels & hostels</div>
              <div><FaHospital /> Hospitals</div>
              <div><FaIndustry /> Food industries & canteens</div>
              <div><FaIndustry /> Poultry & dairy farms</div>
              <div><FaRecycle /> STP / ETP sludge treatment</div>
            </div>
          </div>

          {/* BENEFITS */}
          <div className="biogas-block" data-aos="slide-up" data-aos-delay="200">
            {/* <h3>Benefits of Biogas</h3> */}
            <div className="biogas-grid">
              {/* <div><FaLeaf /> Converts waste into energy</div>
        <div><FaRecycle /> Reduces landfill and sewage load</div>
        <div><FaLeaf /> Cuts greenhouse gas emissions</div>
        <div><FaBolt /> Low operating cost</div>
        <div><FaSeedling /> Produces high-quality organic fertilizer</div>
        <div><FaLeaf /> Ideal for circular economy projects</div> */}
            </div>
          </div>

        </div>
      </section>


      {/* BIOGAS VIDEO BACKGROUND SECTION */}
      <section
        id="biogas-video-bg-section"
        style={{ backgroundImage: `url(${BIOGAS})` }}
      >
        <div
          className="biogas-video-bg-wrapper"
          data-aos="slide-up"
        >
          {/* <video
      className="biogas-bg-video"
      src={VID3}
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
    /> */}
        </div>
      </section>

      {/* BIOGAS – HOW RAD ENVIRO NEX WORKS */}
      {/* <section id="biogas-workflow-section">
  <div className="biogas-workflow-wrapper" data-aos="fade-up">

    <h2>How RAD EnviroNex Works for Biogas Projects</h2>

    <div className="biogas-workflow-grid">

      <div data-aos="slide-up">
        <FaSearch />
        <h4>1. Waste Assessment & Feasibility Study</h4>
        <p>
          RAD EnviroNex begins by analyzing the type, quantity, and consistency
          of organic waste (food waste, cattle dung, poultry waste, agro waste, etc.).
          We evaluate biogas potential, plant capacity, space availability,
          and end-use requirements.
        </p>
      </div>

      <div data-aos="slide-up" data-aos-delay="100">
        <FaDraftingCompass />
        <h4>2. Customized Biogas Plant Design</h4>
        <p>
          Based on site conditions, we design tailor-made biogas systems such as
          floating drum / fixed dome plants, prefabricated digesters, and
          industrial & commercial biogas plants. Design focuses on maximum gas
          yield, safety, odor control, and long-term reliability.
        </p>
      </div>

      <div data-aos="slide-up" data-aos-delay="200">
        <FaTools />
        <h4>3. Engineering, Supply & Installation</h4>
        <p>
          Our team handles civil works, digester construction, gas pipelines,
          storage balloons, safety valves, feedstock handling systems, and
          slurry outlets. All installations follow MNRE guidelines, CPCB norms,
          and local authority approvals.
        </p>
      </div>

      <div data-aos="slide-up" data-aos-delay="300">
        <FaGasPump />
        <h4>4. Biogas Utilization Integration</h4>
        <p>
          RAD EnviroNex integrates biogas usage for cooking & canteen
          applications, boiler & thermal energy systems, and biogas gensets
          for power generation. Systems are optimized to minimize gas losses.
        </p>
      </div>

      <div data-aos="slide-up" data-aos-delay="400">
        <FaRecycle />
        <h4>5. Slurry Management & Organic Manure Recovery</h4>
        <p>
          Treated digestate is processed into liquid bio-fertilizer and
          organic manure suitable for agriculture & landscaping, supporting
          zero-waste and circular economy goals.
        </p>
      </div>

      <div data-aos="slide-up" data-aos-delay="500">
        <FaCheckCircle />
        <h4>6. Testing, Commissioning & Performance Guarantee</h4>
        <p>
          The plant undergoes trial runs, gas output testing, leak checks,
          safety verification, and performance stabilization to ensure
          consistent biogas output as designed.
        </p>
      </div>

      <div data-aos="slide-up" data-aos-delay="600">
        <FaUserGraduate />
        <h4>7. Operation, Training & AMC Support</h4>
        <p>
          RAD EnviroNex provides operator training, SOPs, Annual Maintenance
          Contracts (AMC), and remote & on-site technical support, ensuring
          hassle-free operation and long plant life.
        </p>
      </div>

    </div>
  </div>
</section> */}


      {/* BIOGAS – GOVERNMENT POLICY & REGULATORY */}
      <section id="biogas-policy-section">
        <div className="biogas-policy-wrapper" data-aos="fade-up">

          {/* LOGO CENTER */}
          <div className="biogas-policy-logo" data-aos="zoom-in">
            <img src={RADLOGO} alt="RAD EnviroNex Logo" />
          </div>

          <h2>Government Policy & Regulatory View</h2>

          <p className="biogas-policy-intro">
            RAD EnviroNex aligns with Government of India policies like the
            <strong> National Biogas and Manure Management Programme (NBMMP)</strong>
            and the <strong>SATAT initiative</strong> to help clients access
            subsidies, priority lending, and assured off-take agreements — maximizing
            ROI while contributing to sustainable energy goals.
          </p>

          {/* 1 */}
          <div className="biogas-policy-card" data-aos="slide-up">
            <FaUniversity />
            <div>
              <h4>1. National Biogas and Manure Management Programme (NBMMP)</h4>
              <p>
                A flagship central government initiative under the Ministry of New &
                Renewable Energy (MNRE) aimed at supporting small and medium biogas
                plants across India.
              </p>
              <ul>
                <li>Central subsidy for household & community biogas plants (varies by region, category, and plant size)</li>
                <li>Turn-key job fee with 5-year warranty support on construction and quality control</li>
                <li>Training & capacity building for users, masons, and entrepreneurs</li>
                <li>Additional incentives for SC/ST beneficiaries, hilly regions, and sanitation-linked plants</li>
              </ul>
            </div>
          </div>

          {/* 2 */}
          <div className="biogas-policy-card" data-aos="slide-up" data-aos-delay="100">
            <FaRecycle />
            <div>
              <h4>2. MNRE Waste-to-Energy Programme</h4>
              <p>
                Under the National Bioenergy Programme (2021–26), incentives are
                provided for Waste-to-Energy (W2E) projects including biogas,
                Bio-CNG, and power generation from organic waste.
              </p>
              <ul>
                <li>Central Financial Assistance (CFA) for large Bio-CNG projects (up to ₹10 crore per project)</li>
                <li>Encourages medium & large biogas plants beyond household scale</li>
              </ul>
            </div>
          </div>

          {/* 3 */}
          <div className="biogas-policy-card" data-aos="slide-up" data-aos-delay="200">
            <FaGasPump />
            <div>
              <h4>3. SATAT Initiative (Compressed Biogas Push)</h4>
              <p>
                Launched to promote Compressed Biogas (CBG) as a renewable transport
                fuel and waste management solution.
              </p>
              <ul>
                <li>Target to establish thousands of Bio-CNG / CBG plants nationwide</li>
                <li>Assured offtake via Oil Marketing Companies at pre-determined pricing</li>
                <li>Priority sector lending and long-term purchase agreements</li>
              </ul>
            </div>
          </div>

          {/* 4 */}
          <div className="biogas-policy-card" data-aos="slide-up" data-aos-delay="300">
            <FaMoneyBillWave />
            <div>
              <h4>4. Additional Financial & Technical Support</h4>
              <ul>
                <li>State agencies & biogas training centres support verification and monitoring</li>
                <li>Incentives for biogas-based power and pumping systems</li>
                <li>State-specific benefits like capital subsidies, tax exemptions, and land support</li>
              </ul>
            </div>
          </div>

          {/* 5 */}
          <div className="biogas-policy-card" data-aos="slide-up" data-aos-delay="400">
            <FaChartLine />
            <div>
              <h4>5. Industry & Future Policy Directions</h4>
              <ul>
                <li>IBA proposed a ₹10,000 crore dedicated subsidy fund in Union Budget</li>
                <li>Higher subsidy caps for large CBG projects</li>
                <li>Improved carbon credit mechanisms</li>
                <li>Mandatory use of bio-fertilizer in agriculture</li>
              </ul>
            </div>
          </div>

          {/* FLOW */}
          {/* <div className="biogas-flow" data-aos="slide-up" data-aos-delay="500">
      <FaProjectDiagram />
      <h3>Working of Biogas – Flow Chart</h3>
      <p>
        Organic Waste → Anaerobic Digestion → Biogas Collection →
        Gas Utilization (Cooking / Power / Boiler) →
        Slurry Processing → Organic Manure / Bio-Fertilizer
      </p>
    </div> */}

        </div>
      </section>
      {/* ETP PROCESS IMAGE SECTION */}
      {/* <section id="etp-process-section">
  <div
    className="etp-process-wrapper"
    data-aos="slide-up"
  >
    <h2>Process of Bio Gas</h2>

    <div className="etp-process-image">
      <img src={BIOGASWORK} alt="ETP Process Flow Diagram" />
    </div>
  </div>
</section> */}

      <Footer />
    </>
  )
}
